import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import ErrorWrapper from '../components/common/ErrorWrapper';
import { getUriMap } from '../util/uriMap';

const drawerWidth = 240;

const styles = theme => {
  const makeTransition = (props, duration) =>
    theme.transitions.create(props, {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration[duration],
    });
  return {
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      margin: 'auto',
      [theme.breakpoints.up('lg')]: {
        margin: theme.spacing(1) * 3,
        marginLeft: theme.spacing(1) * 12,
      },
    },
    contentTransition: {
      transition: makeTransition(['width', 'margin'], 'leavingScreen'),
    },
    contentShift: {
      margin: theme.spacing(1) * 3,
      marginLeft: drawerWidth + theme.spacing(1) * 3,
    },
    contentShiftTransition: {
      transition: makeTransition(['width', 'margin'], 'leavingScreen'),
    },
    main: {
      marginBottom: 96,
    },
  };
};

class Main extends React.Component {
  state = { routerHistory: [] };

  componentDidMount() {
    this.setState({ routerHistory: [this.props.location.pathname] });
  }

  static getDerivedStateFromProps(props, state) {
    const uriMap = getUriMap();
    const { location } = props;
    const { routerHistory, firstRenderAfterPageWithoutDrawer } = state;
    const prevPage = routerHistory[routerHistory.length - 1];
    const pagesWithoutDrawer = Object.entries(uriMap).filter(([path, { noAuth, noDrawer }]) => noAuth || noDrawer).map(([path]) => path);

    if (location.pathname !== prevPage) {
      return {
        routerHistory: [...routerHistory, location.pathname],
        firstRenderAfterPageWithoutDrawer: pagesWithoutDrawer.includes(prevPage) && !pagesWithoutDrawer.includes(location.pathname),
      };
    } else if (firstRenderAfterPageWithoutDrawer) {
      return { firstRenderAfterPageWithoutDrawer: false };
    }
    return null;
  }

  static mapStateToProps({ drawer }) {
    return { drawer };
  }

  render() {
    const uriMap = getUriMap();
    const { classes, drawer, width, children, pageError, location } = this.props;
    const { firstRenderAfterPageWithoutDrawer } = this.state;
    const lgUp = width === 'lg' || width === 'xl';
    const shifted = drawer.expanded && lgUp;
    const contentClasses = classNames(
      classes.content,
      firstRenderAfterPageWithoutDrawer ? '' : classes.contentTransition,
    );
    const shiftClasses = classNames(
      classes.contentShift,
      firstRenderAfterPageWithoutDrawer ? '' : classes.contentShiftTransition,
    );
    const pagesWithoutDrawer = Object.entries(uriMap).filter(([path, { noAuth, noDrawer }]) => noAuth || noDrawer).map(([path]) => path);
    const mainClasses = !pagesWithoutDrawer.includes(location.pathname) || pageError ? classNames(contentClasses, shifted && shiftClasses) : '';

    return (
      <main className={classNames(mainClasses, classes.main)}>
        <div className={classes.toolbar} />
        <ErrorWrapper wrap={pageError}>
          {children}
        </ErrorWrapper>
      </main>
    );
  }
}

Main.propTypes = {
  classes: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
};

export default compose(
  withRouter,
  connect(Main.mapStateToProps),
  withStyles(styles),
  withWidth(),
)(Main);
